import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import SEO from "../components/SEO";

const ITEMS = [
  { q: "What sizes do you offer?", a: "All hoodies and tees come in S, M, L, XL, XXL. They are designed oversized — check the Size Guide before ordering." },
  { q: "What payment methods are accepted?", a: "We accept UPI payments (Google Pay, PhonePe, Paytm) and Cash on Delivery (COD)." },
  { q: "Is COD available?", a: "Yes — Cash on Delivery is available across India." },
  { q: "How long does delivery take?", a: "Orders are dispatched within 24-48 hours. Delivery takes 5-7 business days across India including Delhi NCR." },
  { q: "Can I track my order?", a: "Yes — once dispatched, we share tracking details via WhatsApp on +91 8383862206 and email." },
  { q: "Can I cancel my order?", a: "Orders can be cancelled within 12 hours of placement by WhatsApping us at +91 8383862206. Once shipped, cancellations are not possible." },
  { q: "What is your return policy?", a: "No returns except for damaged or wrong items received. Reach out within 48 hours of delivery for a replacement or refund." },
  { q: "How long do refunds take?", a: "Refunds are processed within 7 business days of complaint approval." },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <>
      <SEO title="FAQ" />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <p className="font-mono-cap text-[10px] text-white/40">Help</p>
        <h1 className="font-serif text-5xl mt-2">Questions.</h1>
        <div className="mt-10 divide-y divide-white/10 border-y border-white/10">
          {ITEMS.map((it, i) => (
            <div key={i}>
              <button data-testid={`faq-q-${i}`} onClick={() => setOpen(open === i ? -1 : i)} className="w-full py-5 flex items-center justify-between text-left">
                <span className="text-base">{it.q}</span>
                <ChevronDown size={16} className={`transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p data-testid={`faq-a-${i}`} className="pb-5 text-white/65 text-sm leading-relaxed">{it.a}</p>}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
export default FAQ;
